import React, { Component } from 'react';

import { Row, Col} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import { Player } from 'video-react';
import videoPoster from "../../../Imgs/AboutUs/ManagerMessage/managerPosterVideo.PNG";
import LazyLoad from 'react-lazyload';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/ManagerMessage/ManagerMessage.css";

const managerMessageCard ={
    borderRadius:"20px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
}

const Azar = (props) => {
  return props.size === "laptopdesktop" ? (
    <div className="managerMessageBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>سیزده آذر، روز ملی صنعت بیمه</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescription"> و تاسیس شرکت ایرانیان پوشش</p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={4}></Col>
        <Col span={16}>
          <div style={managerMessageCard}>
            <Row>
              <Col
                span={24}
                style={{
                  direction: "rtl",
                  textAlign: "right",
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                }}
              >
                <Margin top={3}></Margin>
                <div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
                <p className="textParagraph">
                                        به نام خالق زیبایی، دانایی و نیکویی
                                        </p>
                                        <p className="textBoldParagraph">
                                             <strong>
                                             دانه ایرانیان پوشش در ۱۳ آذر سال ۱۳۹۱ کاشت شد و
سیزدهم آذر امسال آغاز دوازدهمین سالگرد فعالیت این مجموعه است.

                                             </strong>
                                        </p>
                                        <p className="textParagraph">
                                        آنان که دستی بر آتش دارند، نیک می‌دانند که در حضور تهدیدها و مخاطراتی چون فضای نامناسب کسب‌وکارها، تحریم‌های اقتصادی، نرخ‌های بالای تورم، محدودیت نقدینگی، نوسانات شدید نرخ ارز، بی‌ثباتی در سیاست‌گذاری‌ها و مداخله‌های غیرهوشمندانه دولت در بازارهای اقتصادی، این شروع و تداوم فعالیت تا چه اندازه کاری شاق و پرهزینه بوده است، بااین‌وجود، سختی راه و سنگلاخی بودن، ناهمواری‌ها و فرازوفرودهای مسیر را با خلق دستاوردهایی در حوزه ارزیابی خسارت و ارزیابی ریسک در همه رشته‌های بیمه‌ای معنادار کردیم.
                                        <br/>
                                        در این ۱۲ سال ۱۲ شرکت راه‌اندازی کردیم و با شعاره ایستگاه نوآوری صنعت بیمه - منهای فروش هرسال یک شرکت جدید را وارد صنعت بیمه نمودیم و هم‌اکنون با خلق نوآوری‌ها با شرکت‌ها و مؤسسات شناخته‌شده‌ای ازجمله اندیشکده بیمه، دادگر بیمه، دادرس بیمه، همیار بیمه، سناپ، سپر، کنکاش بیمه، رفاپ، امداد و نجات، آژانس بیمه، رسانه بیمه از صنعت بیمه کشور مراقبت کردیم، در دل بیمه‌گزاران اعتماد کاشتیم و امیدشان را به این نهاد اطمینان‌بخش افزایش دادیم، یار شرکت‌های بیمه‌گر بودیم و از بار آن‌ها کم کردیم و باعرضه خدمات پر کیفیت ارزیابی خسارت به بیمه‌گزارانشان اهمیت و ارزشمندی خدمات شرکت‌های بیمه‌ای را برجسته ساختیم.
                                        <br/>
                                        در بیش از یک دهه مجال حضور، مهربانانه دست آسیب دیدگان و در راه ماندگان بیمه‌ای را گرفتیم و در دلشان شادی آفریدیم.
                                        <br/>
                                        از همان آغاز کار رویکردمان این بود که در مسیر توسعه صنعت بیمه و افزایش ضریب نفوذ بیمه در کشور، یاریگر نهادهای سیاست‌گذار و هردوی بیمه گران و بیمه‌گزاران باشیم. اکنون، پس از گذشت این‌همه سال که کارنامه خانواده ایرانیان پوشش را مرور می‌کنیم و بازخوردهای مثبت نهادهای ناظر، سیاست‌گذار، شرکت‌های بیمه و بیمه‌گزاران حقیقی و حقوقی را می‌بینیم، خدای مهربان را برای این توفیقات شکر می‌گوییم. این عملکرد در حالی حاصل‌شده که شرکت جدا از فعالیت حرفه‌ای و خدماتی خود، همواره مسئولیت اجتماعی خود را در قبال جامعه ادا کرده و در این زمینه نیز سرآمد بوده است.
                                        <br/>
                                        سالروز تولد ایرانیان پوشش و نام نیکی را که در صنعت بیمه کشور کسب کرده است را به همه مدیران، کارکنان و خانواده ایرانیان پوشش تبریک عرض می‌کنم. به همه این عزیزان دست‌مریزاد و خداقوت می‌گویم و از خدای متعال سلامتی، شادی و آرامش را برایشان خواستارم.
                                        <br/>
                                        <br/>
                                        ابراهیم ایران‌نژاد
                                        <br/>
                                        مدیرعامل گروه شرکت‌های ایرانیان پوشش  
                                        </p>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div className="managerMessageBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
            <strong>سیزده آذر، روز ملی صنعت بیمه</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionTablet">
              و تاسیس شرکت ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "25px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          <div style={managerMessageCard}>
            <Row>
              <Col
                span={24}
                style={{
                  direction: "rtl",
                  textAlign: "right",
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                }}
              >
                <Margin top={3}></Margin>
                <div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
                <p className="textParagraph">
                                        به نام خالق زیبایی، دانایی و نیکویی
                                        </p>
                                        <p className="textBoldParagraph">
                                             <strong>
                                             دانه ایرانیان پوشش در ۱۳ آذر سال ۱۳۹۱ کاشت شد و
سیزدهم آذر امسال آغاز دوازدهمین سالگرد فعالیت این مجموعه است.

                                             </strong>
                                        </p>
                                        <p className="textParagraph">
                                        آنان که دستی بر آتش دارند، نیک می‌دانند که در حضور تهدیدها و مخاطراتی چون فضای نامناسب کسب‌وکارها، تحریم‌های اقتصادی، نرخ‌های بالای تورم، محدودیت نقدینگی، نوسانات شدید نرخ ارز، بی‌ثباتی در سیاست‌گذاری‌ها و مداخله‌های غیرهوشمندانه دولت در بازارهای اقتصادی، این شروع و تداوم فعالیت تا چه اندازه کاری شاق و پرهزینه بوده است، بااین‌وجود، سختی راه و سنگلاخی بودن، ناهمواری‌ها و فرازوفرودهای مسیر را با خلق دستاوردهایی در حوزه ارزیابی خسارت و ارزیابی ریسک در همه رشته‌های بیمه‌ای معنادار کردیم.
                                        <br/>
                                        در این ۱۲ سال ۱۲ شرکت راه‌اندازی کردیم و با شعاره ایستگاه نوآوری صنعت بیمه - منهای فروش هرسال یک شرکت جدید را وارد صنعت بیمه نمودیم و هم‌اکنون با خلق نوآوری‌ها با شرکت‌ها و مؤسسات شناخته‌شده‌ای ازجمله اندیشکده بیمه، دادگر بیمه، دادرس بیمه، همیار بیمه، سناپ، سپر، کنکاش بیمه، رفاپ، امداد و نجات، آژانس بیمه، رسانه بیمه از صنعت بیمه کشور مراقبت کردیم، در دل بیمه‌گزاران اعتماد کاشتیم و امیدشان را به این نهاد اطمینان‌بخش افزایش دادیم، یار شرکت‌های بیمه‌گر بودیم و از بار آن‌ها کم کردیم و باعرضه خدمات پر کیفیت ارزیابی خسارت به بیمه‌گزارانشان اهمیت و ارزشمندی خدمات شرکت‌های بیمه‌ای را برجسته ساختیم.
                                        <br/>
                                        در بیش از یک دهه مجال حضور، مهربانانه دست آسیب دیدگان و در راه ماندگان بیمه‌ای را گرفتیم و در دلشان شادی آفریدیم.
                                        <br/>
                                        از همان آغاز کار رویکردمان این بود که در مسیر توسعه صنعت بیمه و افزایش ضریب نفوذ بیمه در کشور، یاریگر نهادهای سیاست‌گذار و هردوی بیمه گران و بیمه‌گزاران باشیم. اکنون، پس از گذشت این‌همه سال که کارنامه خانواده ایرانیان پوشش را مرور می‌کنیم و بازخوردهای مثبت نهادهای ناظر، سیاست‌گذار، شرکت‌های بیمه و بیمه‌گزاران حقیقی و حقوقی را می‌بینیم، خدای مهربان را برای این توفیقات شکر می‌گوییم. این عملکرد در حالی حاصل‌شده که شرکت جدا از فعالیت حرفه‌ای و خدماتی خود، همواره مسئولیت اجتماعی خود را در قبال جامعه ادا کرده و در این زمینه نیز سرآمد بوده است.
                                        <br/>
                                        سالروز تولد ایرانیان پوشش و نام نیکی را که در صنعت بیمه کشور کسب کرده است را به همه مدیران، کارکنان و خانواده ایرانیان پوشش تبریک عرض می‌کنم. به همه این عزیزان دست‌مریزاد و خداقوت می‌گویم و از خدای متعال سلامتی، شادی و آرامش را برایشان خواستارم.
                                        <br/>
                                        <br/>
                                        ابراهیم ایران‌نژاد
                                        <br/>
                                        مدیرعامل گروه شرکت‌های ایرانیان پوشش  
                                        </p>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  ) : (
    <div className="managerMessageBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
            <strong>سیزده آذر، روز ملی صنعت بیمه</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionMobile">
              و تاسیس شرکت ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <div>
        <Row style={{ marginTop: "25px" }}>
          <Col span={1}></Col>
          <Col span={22}>
            <div
              style={{
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                backgroundColor: "#fff",
                height: "100%",
                borderRadius: "20px",
              }}
            >
              <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px" }}>
                <Margin top={1}></Margin>
                <div
                  style={{
                    padding: "15px",
                    backgroundColor: "#fff",
                    borderRadius: "20px",
                  }}
                >
                  <p className="textParagraph">
                                        به نام خالق زیبایی، دانایی و نیکویی
                                        </p>
                                        <p className="textBoldParagraph">
                                             <strong>
                                             دانه ایرانیان پوشش در ۱۳ آذر سال ۱۳۹۱ کاشت شد و
سیزدهم آذر امسال آغاز دوازدهمین سالگرد فعالیت این مجموعه است.

                                             </strong>
                                        </p>
                                        <p className="textParagraph">
                                        آنان که دستی بر آتش دارند، نیک می‌دانند که در حضور تهدیدها و مخاطراتی چون فضای نامناسب کسب‌وکارها، تحریم‌های اقتصادی، نرخ‌های بالای تورم، محدودیت نقدینگی، نوسانات شدید نرخ ارز، بی‌ثباتی در سیاست‌گذاری‌ها و مداخله‌های غیرهوشمندانه دولت در بازارهای اقتصادی، این شروع و تداوم فعالیت تا چه اندازه کاری شاق و پرهزینه بوده است، بااین‌وجود، سختی راه و سنگلاخی بودن، ناهمواری‌ها و فرازوفرودهای مسیر را با خلق دستاوردهایی در حوزه ارزیابی خسارت و ارزیابی ریسک در همه رشته‌های بیمه‌ای معنادار کردیم.
                                        <br/>
                                        در این ۱۲ سال ۱۲ شرکت راه‌اندازی کردیم و با شعاره ایستگاه نوآوری صنعت بیمه - منهای فروش هرسال یک شرکت جدید را وارد صنعت بیمه نمودیم و هم‌اکنون با خلق نوآوری‌ها با شرکت‌ها و مؤسسات شناخته‌شده‌ای ازجمله اندیشکده بیمه، دادگر بیمه، دادرس بیمه، همیار بیمه، سناپ، سپر، کنکاش بیمه، رفاپ، امداد و نجات، آژانس بیمه، رسانه بیمه از صنعت بیمه کشور مراقبت کردیم، در دل بیمه‌گزاران اعتماد کاشتیم و امیدشان را به این نهاد اطمینان‌بخش افزایش دادیم، یار شرکت‌های بیمه‌گر بودیم و از بار آن‌ها کم کردیم و باعرضه خدمات پر کیفیت ارزیابی خسارت به بیمه‌گزارانشان اهمیت و ارزشمندی خدمات شرکت‌های بیمه‌ای را برجسته ساختیم.
                                        <br/>
                                        در بیش از یک دهه مجال حضور، مهربانانه دست آسیب دیدگان و در راه ماندگان بیمه‌ای را گرفتیم و در دلشان شادی آفریدیم.
                                        <br/>
                                        از همان آغاز کار رویکردمان این بود که در مسیر توسعه صنعت بیمه و افزایش ضریب نفوذ بیمه در کشور، یاریگر نهادهای سیاست‌گذار و هردوی بیمه گران و بیمه‌گزاران باشیم. اکنون، پس از گذشت این‌همه سال که کارنامه خانواده ایرانیان پوشش را مرور می‌کنیم و بازخوردهای مثبت نهادهای ناظر، سیاست‌گذار، شرکت‌های بیمه و بیمه‌گزاران حقیقی و حقوقی را می‌بینیم، خدای مهربان را برای این توفیقات شکر می‌گوییم. این عملکرد در حالی حاصل‌شده که شرکت جدا از فعالیت حرفه‌ای و خدماتی خود، همواره مسئولیت اجتماعی خود را در قبال جامعه ادا کرده و در این زمینه نیز سرآمد بوده است.
                                        <br/>
                                        سالروز تولد ایرانیان پوشش و نام نیکی را که در صنعت بیمه کشور کسب کرده است را به همه مدیران، کارکنان و خانواده ایرانیان پوشش تبریک عرض می‌کنم. به همه این عزیزان دست‌مریزاد و خداقوت می‌گویم و از خدای متعال سلامتی، شادی و آرامش را برایشان خواستارم.
                                        <br/>
                                        <br/>
                                        ابراهیم ایران‌نژاد
                                        <br/>
                                        مدیرعامل گروه شرکت‌های ایرانیان پوشش  
                                        </p>
                </div>
              </div>
            </div>
          </Col>
          <Col span={1}></Col>
        </Row>
      </div>
    </div>
  );
};

export default Azar;
